import { api } from './api';

// QR BOOKING INSIGHTS (admin, read-only) — mirrors the backend `/admin/ops/qr-insights` response shape.
// Everything is derived from qr_web rides + driver_qr_tokens; see QR-WEB-BOOKING-HANDOFF.md §3 Task A.

export interface QrFunnel {
  booked: number;
  started: number;
  completed: number;
  expiredUnclaimed: number;
  otherCancelled: number;
  startedPct: number;   // started / booked
  completedPct: number; // completed / started
}

export interface QrMoney {
  revenue: number;
  avgFare: number | null;
  avgDistanceKm: number | null;
}

export interface QrBreakdownRow {
  key: string;          // city name or ride type ('—' when unknown)
  booked: number;
  completed: number;
  revenue: number;
}

export interface QrDayBucket {
  day: string;          // YYYY-MM-DD (IST)
  booked: number;
  completed: number;
  revenue: number;
}

export interface QrTopDriver {
  driverId: string;
  name: string | null;
  plate: string | null;
  completed: number;
  revenue: number;
}

export interface QrInsights {
  range: { from: string; to: string };
  cityId: string | null;
  funnel: QrFunnel;
  money: QrMoney;
  byCity: QrBreakdownRow[];
  byType: QrBreakdownRow[];
  byDay: QrDayBucket[];
  adoption: { tokens: number; tokensRevoked: number; activeDrivers: number };
  topDrivers: QrTopDriver[];
  health: { avgClaimSecs: number | null; medianClaimSecs: number | null };
}

export interface QrInsightsParams {
  from: string;   // YYYY-MM-DD
  to: string;     // YYYY-MM-DD
  cityId?: string;
}

export const getQrInsights = (params: QrInsightsParams) =>
  api.get<{ success: boolean; data: QrInsights }>('/admin/ops/qr-insights', { params });
